import React from "react";
import { formatGBP } from "../../lib/format";

export default function AnalyticsOverview({ overview }) {
  if (!overview) return null;
  return (
    <div data-testid="admin-analytics-overview">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <div className="card-surface p-5">
          <p className="text-xs font-bold tracking-wider uppercase text-[#5C5C54] mb-1">Paid revenue</p>
          <p className="font-heading text-3xl font-black">{formatGBP(overview.revenue.total)}</p>
          <p className="text-xs text-[#5C5C54] mt-1">Live Stripe transactions</p>
        </div>
        <div className="card-surface p-5">
          <p className="text-xs font-bold tracking-wider uppercase text-[#5C5C54] mb-1">Service fees earned</p>
          <p className="font-heading text-3xl font-black">{formatGBP(overview.revenue.service_fees)}</p>
        </div>
        <div className="card-surface p-5">
          <p className="text-xs font-bold tracking-wider uppercase text-[#5C5C54] mb-1">Paid orders</p>
          <p className="font-heading text-3xl font-black">{overview.orders.total}</p>
          <p className="text-xs text-[#5C5C54] mt-1">{overview.orders.today} today · {overview.orders.this_week} this week</p>
        </div>
        <div className="card-surface p-5">
          <p className="text-xs font-bold tracking-wider uppercase text-[#5C5C54] mb-1">Users</p>
          <p className="font-heading text-3xl font-black">{overview.users.total}</p>
        </div>
        <div className="card-surface p-5">
          <p className="text-xs font-bold tracking-wider uppercase text-[#5C5C54] mb-1">Approved vendors</p>
          <p className="font-heading text-3xl font-black">{overview.vendors.approved}</p>
          <p className="text-xs text-[#5C5C54] mt-1">{overview.vendors.pending} pending</p>
        </div>
        <div className="card-surface p-5">
          <p className="text-xs font-bold tracking-wider uppercase text-[#5C5C54] mb-1">Products</p>
          <p className="font-heading text-3xl font-black">{overview.products.total}</p>
        </div>
        <div className="card-surface p-5 md:col-span-2">
          <p className="text-xs font-bold tracking-wider uppercase text-[#5C5C54] mb-2">Top vendors</p>
          {overview.top_vendors.map((v) => (
            <div key={v.vendor_id} className="flex justify-between items-center py-1.5 text-sm">
              <span className="truncate pr-2">{v.name}</span>
              <span className="font-bold flex-shrink-0">{v.total_orders} orders</span>
            </div>
          ))}
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="card-surface p-5">
          <p className="text-xs font-bold tracking-wider uppercase text-[#5C5C54] mb-3">Top products</p>
          {overview.top_products.map((p) => (
            <div key={p.product_id} className="flex justify-between items-center py-1.5 text-sm">
              <div className="truncate pr-2">
                <p className="font-bold truncate">{p.name}</p>
                <p className="text-xs text-[#5C5C54] truncate">{p.vendor_name}</p>
              </div>
              <span className="font-bold text-xs flex-shrink-0">{p.total_sold} sold</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
